import { FunnelType } from "@/lib/utils";

import React, { createContext } from "react";

export interface JourneyContextValue {
    isOpen: boolean;
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    unitJourneyStep: string;
    setUnitJourneyStep: React.Dispatch<React.SetStateAction<string>>;
    funnelType: FunnelType | undefined;
    setFunnelType: React.Dispatch<React.SetStateAction<FunnelType | undefined>>;
    selectedUnitId: number | string;
    setSelectedUnitId: React.Dispatch<React.SetStateAction<number | string>>;
    stepList: string[];
}

export const UnitJourneyContext = createContext<JourneyContextValue | null>(
    null,
);
UnitJourneyContext.displayName = "UnitJourneyContext";
